import { useEffect, useState } from 'react'

const DESKTOP_QUERY = '(min-width: 768px)' // 与项目响应式惯例断点一致；<768px 视为手机

/**
 * 视口是否为手机（<768px）。
 * matchMedia change 事件驱动，只在跨断点时触发，无 resize 防抖问题；
 * 惰性初始化保证手机首帧即为 true（桌面侧栏不会闪现）。
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window.matchMedia === 'function' && !window.matchMedia(DESKTOP_QUERY).matches,
  )

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return
    const mql = window.matchMedia(DESKTOP_QUERY)
    const onChange = (e: MediaQueryListEvent) => setIsMobile(!e.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
